import { RawUnit } from "@/types/rawUnit";
import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export interface SellerState {
	// Seller's raw units and properties
	rawUnitAndProperties: RawUnit[];
	hasRawUnitAndProperties: boolean;

	setHasRawUnitAndProperties: (hasProperties: boolean) => void;
	setProperties: (rawUnitAndProperties: RawUnit[]) => void;
	addProperty: (property: RawUnit) => void;
	updateProperty: (propertyId: string, updates: Partial<RawUnit>) => void;
	removeProperty: (propertyId: string) => void;
}

export const useSellerStore = create<SellerState>()(
	devtools(
		subscribeWithSelector(
			immer(set => ({
				rawUnitAndProperties: [],
				hasRawUnitAndProperties: false,

				// Properties actions
				setHasRawUnitAndProperties: hasProperties =>
					set(state => {
						state.hasRawUnitAndProperties = hasProperties;
					}),

				setProperties: rawUnitAndProperties =>
					set(state => {
						state.rawUnitAndProperties = rawUnitAndProperties;
					}),

				addProperty: property =>
					set(state => {
						state.rawUnitAndProperties.push(property);
					}),

				updateProperty: (propertyId, updates) =>
					set(state => {
						const index = state.rawUnitAndProperties.findIndex(p => p.id === propertyId);
						if (index !== -1) {
							state.rawUnitAndProperties[index] = { ...state.rawUnitAndProperties[index], ...updates };
						}
					}),

				removeProperty: propertyId =>
					set(state => {
						state.rawUnitAndProperties = state.rawUnitAndProperties.filter(p => p.id !== propertyId);
					}),
			})),
		),
		{ name: "seller-store" },
	),
);
